import React from 'react';
import '../../styles/components/AsperaDesktopClientRedirect.scss';
import { language } from '../../services/LanguageService';
import { Button } from '../Carbon';
import { observableTimeout, openNewTab } from '../../helpers/starterHelpers';
import { SubManager } from '../../classes/SubManager';
import { testConnection } from '@ibm-aspera/sdk';
import { from, mergeMap } from 'rxjs';
/**
 * React Component
 *
 * The AsperaDesktopClientRedirect renders the redirect URI screen.
 * The server should redirect to the URI after loading or rendering this view.
 * For login pages pass this component to the <AsperaLoginPage /> component as `overrideContent`.
 *
 * @example
 * ```javascript
 * <AsperaDesktopClientRedirect />
 * ```
 */
export class AsperaDesktopClientRedirect extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            desktopLoaded: false,
        };
        this.subManager = new SubManager();
        this.pollDesktop = () => {
            this.subManager.setSubscription(observableTimeout(3000).pipe(mergeMap(() => from(testConnection()))).subscribe({
                next: () => {
                    this.setState({ desktopLoaded: true });
                },
                error: () => {
                    this.pollDesktop();
                },
            }));
        };
    }
    get mainView() {
        const { desktopLoaded } = this.state;
        const { redirectUriLink } = this.props;
        if (desktopLoaded) {
            return (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "aspera-desktop-client-redirect--title" }, language.get('desktopClientRedirect.titleLoaded')),
                React.createElement("h4", { className: "aspera-desktop-client-redirect--subtitle" }, language.get('desktopClientRedirect.subTitleLoaded'))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: "aspera-desktop-client-redirect--title" }, language.getStyled('desktopClientRedirect.title')),
                React.createElement("h4", { className: "aspera-desktop-client-redirect--subtitle" }, language.getStyled('desktopClientRedirect.subTitle')),
                React.createElement(Button, { kind: "tertiary", className: "aspera-desktop-client-redirect--action", onClick: () => openNewTab(redirectUriLink, true) }, language.get('desktopClientRedirect.launchIbmAspera'))));
        }
    }
    componentDidMount() {
        this.pollDesktop();
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className, supportLink } = this.props;
        return (React.createElement("div", { className: `aspera-desktop-client-redirect ${className ? className : ''}` },
            this.mainView,
            !!supportLink && React.createElement("div", { className: "aspera-desktop-client-redirect--help" }, language.getStyled('desktopClientRedirect.supportHelp', undefined, [supportLink]))));
    }
}
